import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '@/shared/context/context';
import signalRMessages from '@/redux/actions/signalRMessages';
import { trpc } from '@/config/trpc';
import useNotification from '@/shared/hooks/UseNotification';
import useSocketEvent from '@/shared/hooks/useSocketEvent';

const useGlobalBatchPreparationFinishedMessage = () => {
  const { currentTeamUser } = useContext(AppContext);
  const { sendNotification } = useNotification();
  const { t } = useTranslation();
  const trpcUtils = trpc.useUtils();

  useSocketEvent(signalRMessages.BatchPreparationFinished, (...args: string[]) => {
    const [batchId, description, userId] = args;

    if (userId && userId !== currentTeamUser?.userId) {
      return;
    }

    if (!batchId) {
      return;
    }

    trpcUtils.mail.batch.byId.invalidate({ id: batchId });
    trpcUtils.mail.batch.message.list.invalidate({ id: batchId });
    trpcUtils.mail.batch.incompleteBatchCount.invalidate();

    sendNotification({
      header: t('success'),
      message: t('_globalMessages.receiver', { description }),
      onSuccessRoute: `/batch/${batchId}`,
      options: {
        autoHideDuration: 10000,
      },
      variant: 'success',
    });
  });
};

export default useGlobalBatchPreparationFinishedMessage;
